export class StompConfigurationDto {
	url: string;
	port: number;
	username: string;
	password: string;
	vhost: string;
}
